import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c385e21"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kong" }, null, -1))
const _hoisted_2 = { class: "nav" }

import router from "@/router";
import { Icon } from "vant";
// import { defineProps } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  title: String,
  iconLeft: String,
},
  setup(__props) {

const props = __props;



const goBack = () => {
  if (props.iconLeft === "arrow-left") {
    router.back()
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Icon), {
        name: __props.iconLeft,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
      }, null, 8, ["name"]),
      _createElementVNode("div", null, _toDisplayString(__props.title), 1),
      _createVNode(_unref(Icon), { name: "ellipsis" })
    ])
  ], 64))
}
}

})